export function keyExists(obj, k) {
    return Object.keys(obj).includes(k);
}
